module.exports = __webpack_public_path__ + "static/media/order_up_Gray.986112a7.svg";